export { default } from './CreditInformationButton';
